import React, { Component } from 'react';

/*import logo from '../image/logo.svg';*/
import '../css/App.css';

import { BrowserRouter as Router, Route } from "react-router-dom";

import AppTemplate from '../commons/ui/components/AppTemplate';
import AsyncComponent from '../commons/async/AsyncComponent';
import basePath from '../commons/utils/basePath';

const home = () => import('../modules/home/index');
const products = () => import('../modules/products/index');
const autotrollymachine = () => import('../modules/autotrollymachine/index');
const ecotop = () => import('../modules/ecotop/index');
const aboutus = () => import('../modules/aboutus/index');
const contactus = () => import('../modules/contactus/index');

class App extends Component {
  render() {
    return (
      <Router>
      <AppTemplate>
        <Route path={basePath``} exact={true} component={() => <AsyncComponent moduleProvider={home} />} />
        <Route path={basePath`products`} exact={true} component={() => <AsyncComponent moduleProvider={products} />} />
        <Route path={basePath`auto-trolly-machine`} exact={true} component={() => <AsyncComponent moduleProvider={autotrollymachine} />} />
        <Route path={basePath`eco-top`} exact={true} component={() => <AsyncComponent moduleProvider={ecotop} />} />
        <Route path={basePath`aboutus`} exact={true} component={() => <AsyncComponent moduleProvider={aboutus} />} />
        <Route path={basePath`contactus`} exact={true} component={() => <AsyncComponent moduleProvider={contactus} />} />
      </AppTemplate>
     </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/route/App.js